<template>
  <div class="py-12">
    <section class="grid lg:grid-cols-3 md:grid-cols-3 gap-8">
      <b-card
        no-body
        v-for="(item, index) in cards"
        :key="index"
        class="rounded-xl"
      >
        <div>
          <div class="w-full">
            <img
              :src="item.img"
              alt="img"
              class="w-full rounded-t-xl card-img-h180px object-cover"
            />
          </div>
          <div class="w-full p-6">
            <h5 class="font-bold fsize16">{{ item.title }}</h5>
            <p class="fsize14 font-medium mt-2">{{ item.mute }}</p>
            <div>
              <div class="progress-default">
                <div class="progress-percentage">
                  <span>60%</span>
                </div>
              </div>
              <base-progress height="8" type="warning" value="60" size="lg">
                <slot label> da </slot>
              </base-progress>
            </div>
            <p class="meta font-semibold text-primary fsize14 sm-fsize14">
              {{ item.hours }}
            </p>
          </div>
        </div>
      </b-card>
    </section>
  </div>
</template>
<script>
export default {
  data() {
    return {
      cards: [
        {
          id: "01",
          img: require("@/views/e-learning/img/mylearning/1.png"),
          title: "Microsoft Excel - Excel from Beginner to Advanced",
          mute: "Shobuj Roy",
          hours: "LESSON 23 OF 46 | 2m",
        },
        {
          id: "02",
          img: require("@/views/e-learning/img/mylearning/2.png"),
          title: "Microsoft Excel - Excel from Beginner to Advanced",
          mute: "Shobuj Roy",
          hours: "LESSON 23 OF 46 | 2m",
        },
      ],
    };
  },
};
</script>
